module.exports = __webpack_public_path__ + "img/ukraine.ff1a325.webp";